module.exports = __webpack_public_path__ + "static/media/icn_mainnav_collections_small.fd1c150d.svg";